/**
 * Used to give a user predefined and preselected set of permissions for a given role.
 * e.g. { ..., powerUser: ['UserAdmin', 'BegBalAdmin', 'ChartAdmin'] }
 */
import { assignmentTypes } from '../shared/authorization/assignmentTypes';

export const DefaultPermissionPerRole = {
  superUser: [],
  powerUser: [],
  user: [],
};

export const ConfirmDialogModal = 'ConfirmDialogModal';
export const SetLastClientIdModal = 'SetLastClientIdModal';

export const ALL_ASSIGNMENTS_CODE = 'SpecialTypeAL';

export const userAssignment = {
  assignmentType: assignmentTypes.USER,
  assignmentCode: 'SSO',
};
